.body{
  font-size: 16px;
  font-weight: 500;
  margin: 24px 0;
  max-width: 350px;
  white-space: pre-wrap;
  max-height: calc(100vh - 319px);
  overflow-y: auto;
}

.dontShowAgain {
  padding: 12px 0;
  font-weight: 500;
  display: flex;
  align-items: center;

  & > span {
    margin-left: 10px;
    line-height: 1;
    font-size: 14px;
  }
}

.confirmModal {
  &.warning, &.confirm {
    > div > span {
      width: 100%;
    }

    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 15px;
      gap: 5px;
    }

    > div {
      justify-content: start;
      align-items: normal;
    }

    div[data-testid="confirm-modal-body"] {
      font-weight: normal;
    }

    .icon {
      border-radius: 15%;
      height: 55px;
      width: 55px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
      
      svg {
        width: 42px;
        height: 42px;
      }
    }

    .buttons {
      justify-content: center;
      gap: 20px;
    }
  }
  
  &.warning {
    .icon {
      @include themify($themes) {
        background-color: rgba(themed("error-primary"), 0.25);
      }

      svg {
        @include themify($themes) {
          color: themed("error-primary");
        }
      }
    }
    
    .buttons [data-testid="modal-buttons-submit-button"] {
      @include themify($themes) {
        background-color: rgba(themed("error-primary"), 0.9);
        color: themed("main-secondary");
      }
      
      &:hover {
        @include themify($themes) {
          background-color: themed("error-primary");
        }
      }
    }
  }
}
